export enum FormStepSections {
  Welcome = 'Welcome',
  Dependents = 'About You',
  Medical = 'Health Plans',
  Dental = 'Extra Protection',
  // BeyondHealth = 'Beyond Health',
  Summary = 'Summary',
  HealthQuestion = 'Health Questions',
  Finish = 'Finish Up',
  CoverageStartDate = 'Coverage Start Date',
  EstimateResult = 'Health Questions',
}

export enum FormStepID {
  Welcome = 'welcome',
  Dependents = 'dependents',
  HealthPlans = 'health_plans',
  DentalPlans = 'dental_plans',
  VisionPlans = 'vision_plans',
  AccidentPlans = 'accident_plans',
  CriticalIllnessPlans = 'critical_illness_plans',
  HospitalIndemnityPlans = 'hospital_indemnity_plans',
  PHQ = 'phq',
  Medications = 'medications',
  MedicalConditions = 'medical_conditions',
  EffectiveDate = 'effective_date',
  Legal = 'legal',
  Approved = 'approved',
  Rejected = 'rejected',
  PlanSummary = 'plan_summary',
  Payment = 'payment',
  CoverageStartDate = 'coverage_start_date',
}
